import { FETCH_TYPES, parseURL } from "../Connect";
import SystemConfig, {
  CONFIG_PARAMS,
  GAMECONF_PARAMS,
} from "../../system/SystemConfig";
import AddResult from "../result/AddResult";
import FetchAjax from "../FetchAjax";
import IConnectControl from "../controllers/IConnectControl";
import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import AbstractConnect from "./AbstractConnect";
import IDOM from "../../ui/IDOM";

@injectable()
export default class ConnectAjaxReplay extends AbstractConnect {
  public readonly fetchType: string = FETCH_TYPES.REPLAY;
  timeout: number = 20000;

  constructor(
    @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    @inject(SERVICE_IDENTIFIER.ConnectControl) control: IConnectControl,
    @inject(SERVICE_IDENTIFIER.FetchAjax) fetch: FetchAjax,
    @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM
  ) {
    super(config, control, fetch, dom);
  }

  setTimeout(timeout: number | undefined): void {
    if (timeout && timeout > 0) {
      this.timeout = timeout * 1000;
      // @ts-ignore
      super.ajaxLoadingTimeout = this.timeout / 9;
    }
  }

  async fetch(data) {
    this.control.reset();
    this.data = data;

    this.initTimeoutLoading();

    try {
      let res = await this._fetch();
      let addResult = this.getFakeAddResult(res);
      this.isSilentClose = addResult.isSilentClose();
      return addResult;
    } catch (e) {
      return await Promise.reject(e);
    }
  }

  protected getParams(): Record<string, any> {
    let params = {
      casino_id: this.data.casinoId,
      internal: this.data.internal,
      round_id: this.data.replayRound,
      session_id: this.data.replaySession,
    };

    return params;
  }

  protected getUrl(): string {
    if (this.isInternal()) {
      this.setTimeout(this.config.get(CONFIG_PARAMS.TIMEOUTS)?.replay);
      this.setMethod(this.config.get(CONFIG_PARAMS.URL_REPLAY_METHOD));
      return parseURL(this.config.get(CONFIG_PARAMS.URL_REPLAY), {
        casino_id: this.data.casinoId,
        internal: this.data.internal,
      });
    } else if (this.isSessionRound()) {
      this.setTimeout(this.config.get(CONFIG_PARAMS.TIMEOUTS)?.replay_round);
      this.setMethod(this.config.get(CONFIG_PARAMS.URL_REPLAY_ROUND_METHOD));
      return parseURL(this.config.get(CONFIG_PARAMS.URL_REPLAY_ROUND), {
        casino_id: this.data.casinoId,
        session_id: this.data.replaySession,
        round_id: this.data.replayRound,
      });
    } else {
      console.warn(`ConnectAjaxReplay Error: wrong URL parameters!!!`);
    }
  }

  isInternal(): boolean {
    return this.data.casinoId !== undefined && this.data.internal !== null;
  }

  isSessionRound(): boolean {
    return (
      this.data.casinoId !== undefined &&
      this.data.replaySession !== null &&
      this.data.replayRound !== null
    );
  }

  private getFakeAddResult(res: any) {
    res.data.result = res.data.math_result;
    res.data.silent_close = true;
    res.data.balance = res.data.result?.credit | 0;
    let result = new AddResult(res.data);
    return result;
  }
}
